import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import { DashboardNoticeType } from "../../../../enums";

interface Props {
  type: DashboardNoticeType;
  closable?: boolean;
  style?: React.CSSProperties;
  onClose?: (event?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

export const DashboardNoticeTypeTag = ({ type, closable, style, onClose }: Props) => {
  const { t } = useTranslation();

  let color: string;

  switch (type) {
    case DashboardNoticeType.INFO:
      color = "blue";
      break;
    case DashboardNoticeType.WARNING:
      color = "orange";
      break;
    case DashboardNoticeType.ERROR:
      color = "red";
      break;
  }

  return (
    <Tag color={color} closable={closable} style={{ width: 84, textAlign: "center", ...style }} onClose={onClose}>
      {t("dashboard.notices.enums.type." + type)}
    </Tag>
  );
};
